import { Check, Copy } from "lucide-react"
import { useState, type MouseEvent } from "react"

import { cn } from "../../lib/utils"

type CopyValueProps = {
  value: string
  className?: string
  label?: string
}

export function CopyValue({ value, className, label }: CopyValueProps) {
  const [copied, setCopied] = useState(false)

  async function handleCopy(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation()
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // clipboard may be blocked; ignore
    }
  }

  const visibleLabel = copied ? "Copied" : label
  return (
    <button
      type="button"
      onClick={handleCopy}
      title={copied ? "Copied" : "Click to copy"}
      aria-label={copied ? "Copied" : (label ?? `Copy ${value}`)}
      className={cn(
        "group inline-flex cursor-pointer items-center gap-1.5 break-all text-left transition-colors hover:text-foreground",
        className
      )}
    >
      <span aria-live="polite">{label ? visibleLabel : value}</span>

      {copied ? (
        <Check className="size-3 shrink-0 text-success" />
      ) : (
        <Copy className="size-3 shrink-0 opacity-50 transition-opacity group-hover:opacity-80 group-focus-visible:opacity-80" />
      )}
    </button>
  )
}
